// extracted by mini-css-extract-plugin
export var primary = "#06004d";
export var searchBarContainer = "SearchComponent-module--search-bar-container---UNGA";
export var secondary = "#4dafd7";